import Vue from 'vue'
import VueRouter from "vue-router"
import Vuex from 'vuex'
import Index from './components/Index'
import storeMap from './store/init'
import VueLazyload from 'vue-lazyload'
import dePost from './assets/images/fill.png'
import cookie from 'vue-cookie'
// import dePost1 from './assets/images/post1.png'
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: dePost,
    loading: dePost,
    attempt: 1
});

Vue.use(VueRouter);
Vue.use(Vuex)

const
    ua = navigator.userAgent.toLocaleLowerCase(),
    mobileOn = ua.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
if (mobileOn && true) {
    import('./css/mobile/commom.scss');
} else {
    import('./css/commom.scss');
}

Vue.prototype.vueGloble = {
    isMobile: mobileOn && true
};

Vue.prototype.$cookie = cookie;
Vue.config.productionTip = false;
const
    router = mobileOn ? new VueRouter({
        routes: [
            { path: "/", component: () => import('./components/HomePage.vue') },
            { path: "/index", component: () => import('./components/WapHome.vue') },
            { path: "/category", component: () => import('./components/WapCategory.vue'), props: (route) => ({ ...route.query }) },
            { path: "/result", component: () => import('./components/WapResult.vue'), props: (route) => ({ ...route.query }) },
            { path: "/play", component: () => import('./components/WapPlay.vue'), props: (route) => ({ ...route.query }) },
            { path: "/intro", component: () => import('./components/Introduction.vue') },
            { path: "/contact", component: () => import('./components/ContactUs.vue') }
        ]
    }) : new VueRouter({
        routes: [
            { path: "/", component: () => import('./components/HomePage.vue') },
            { path: "/index", component: () => import('./components/Home.vue') },
            { path: "/category", component: () => import('./components/Category.vue'), props: (route) => ({ ...route.query }) },
            { path: "/result", component: () => import('./components/Result.vue'), props: (route) => ({ ...route.query }) },
            { path: "/play", component: () => import('./components/Play.vue'), props: (route) => ({ ...route.query }) },
            { path: "/intro", component: () => import('./components/Introduction.vue') },
            { path: "/contact", component: () => import('./components/ContactUs.vue') }
        ]
    }),
    store = new Vuex.Store({ ...storeMap });
router.beforeEach((to, from, next) => {
    next();
})
new Vue({
    store,
    router,
    render: h => h(Index),
}).$mount('#app')
